import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { setCookie, hasCookie } from 'services/actions/cookies_actions';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

const OnboardingFirstBulletinModal = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    setShowModal(
      !hasCookie('onboardingFirstBulletin') && profile.in_sample && profile.first_bulletin_unread,
    );
  }, []);

  useEffect(() => {
    if (showModal) setCookie('onboardingFirstBulletin', true);
  }, [showModal]);

  const handleClose = () => setShowModal(false);

  return (
    <Modal size="lg" show={showModal}>
      <Container>
        <div className="modal-body">
          <button aria-label="Close" className="close" onClick={handleClose} type="button">
            <span aria-hidden="true">×</span>
          </button>
          <div className="row mx-0">
            <div className="col-4 bg-modal-first-bulletin rounded" />
            <div className="col-8">
              <h4>Seu primeiro boletim está disponível!</h4>
              <p>
                Você já pode ver novas oportunidades de licitações que surgiram e separamos para sua
                empresa de acordo com o segmento que você escolheu.
              </p>
              <p>
                Se não estiverem de acordo com suas necessidades, avise-nos, pois nossa maior
                especialidade é justamente selecionar e filtrar para você as melhores oportunidades.
              </p>
              <div className="text-center">
                <a className="btn btn-primary" href="/boletim_web/public/boletins">
                  Acessar boletim
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default OnboardingFirstBulletinModal;
